










import {Component, Prop, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class SlidingImageAndTextBlock extends Vue {
    @Prop({default: ''})
    public header!: string;
    @Prop({default: ''})
    public body!: string;
    @Prop({default: ''})
    public image!: string;
    @Prop({default: true})
    public slideFromRight!: boolean;
    @Prop({default: '#2c2e32'})
    public color!: string;
    @Prop({default: 'white'})
    public textColor!: string;
    @Prop({default: false})
    public contain!: boolean;

    @Prop({default: () => undefined})
    public learnMore!: any;

    public textHeight = 0;
    public scrolledIntoView = false;


    public get collapsed() {
        return !this.isLG(true);
    }

    public onVisibilityChanged({direction, going}) {
        if (!this.scrolledIntoView) {
            this.scrolledIntoView = going === 'in';
        }
    }

    public mounted() {
        this.setTextHeight();
    }

    public setTextHeight() {
        if (!nil(this.$refs.sibtext)) {
            this.textHeight = (this.$refs.sibtext as any).clientHeight;
        }
    }

    public get imageStyle() {
        const height = this.collapsed ? 'min-height:50vh;' : `min-height: 40vh; max-height: ${(this.textHeight * 1.25)}px;`;
        return `
        ${this.collapsed ? 'width:100%;' : ''}
        background-size: cover;
        background-position: center top;
        ${height}
    `;
    }

    public get classForRoot() {
        return {
            'small-slider': this.collapsed,
            'pt-5': !this.collapsed,
            'pb-5': !this.collapsed,
        };
    }

}
